export default __webpack_public_path__ + "static/media/Logo without text.e3a1157c.png";